import { createContext } from 'react';

/**
 * Context used to store pricing page state
 */
const PricingContext = createContext(null);

export default PricingContext;
